import React, { useState, useMemo } from 'react';
import { ManageRoutesFilters } from '../../components/delivery-management/ManageRoutesFilters';
import { RouteSummaryStats } from '../../components/delivery-management/RouteSummaryStats';
import { BookingJobsList } from '../../components/delivery-management/BookingJobsList';
import { useGetDeliveryJobsQuery } from '../../store/slices/apiSlice';
import type { RouteSummary } from '../../types/deliveryManagement';

export const BookingDetails: React.FC = () => {
  // Filter state
  const [selectedDate, setSelectedDate] = useState<string>(
    new Date().toISOString().split('T')[0] // Today
  );
  const [selectedEngineerId, setSelectedEngineerId] = useState<string>('');
  const [isLoaded, setIsLoaded] = useState(false);

  // Fetch delivery jobs when loaded
  const { data: jobsData, isLoading, isError, error } = useGetDeliveryJobsQuery(
    {
      potential_delivery_date__date: selectedDate,
      delivery_user: selectedEngineerId || undefined,
      ordering: 'potential_delivery_date,-created_at',
    },
    { skip: !isLoaded || !selectedDate || !selectedEngineerId }
  );

  const jobs = jobsData?.results || [];

  // Calculate summary stats
  const summary: RouteSummary = useMemo(() => {
    const jobCount = jobs.length;
    const totalAmount = jobs.reduce((sum: number, job: any) => {
      return sum + parseFloat(job.total_amount || '0');
    }, 0);
    const totalQuantity = jobs.reduce((sum: number, job: any) => {
      return sum + (job.total_items || 0);
    }, 0);

    return { jobCount, totalAmount, totalQuantity };
  }, [jobs]);

  const handleLoadRoutes = () => {
    setIsLoaded(true);
  };

  return (
    <>
      {/* Filters */}
      <ManageRoutesFilters
        selectedDate={selectedDate}
        selectedEngineerId={selectedEngineerId}
        onDateChange={setSelectedDate}
        onEngineerChange={setSelectedEngineerId}
        onLoadRoutes={handleLoadRoutes}
        isLoading={isLoading}
      />

      {/* Summary Stats */}
      <RouteSummaryStats 
        summary={summary} 
        isVisible={isLoaded && jobs.length > 0} 
      />

      {/* Job Cards List */}
      <BookingJobsList
        jobs={jobs}
        isLoading={isLoading}
        isError={isError}
        error={error}
        isLoaded={isLoaded}
      />
    </>
  );
};
